import { render, staticRenderFns } from "./TheRoadmapItems.vue?vue&type=template&id=15fbf42b&scoped=true&"
import script from "./TheRoadmapItems.vue?vue&type=script&lang=ts&"
export * from "./TheRoadmapItems.vue?vue&type=script&lang=ts&"
import style0 from "./TheRoadmapItems.vue?vue&type=style&index=0&id=15fbf42b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fbf42b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15fbf42b')) {
      api.createRecord('15fbf42b', component.options)
    } else {
      api.reload('15fbf42b', component.options)
    }
    module.hot.accept("./TheRoadmapItems.vue?vue&type=template&id=15fbf42b&scoped=true&", function () {
      api.rerender('15fbf42b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TheRoadmapItems.vue"
export default component.exports